<template>
	<!-- 执行标准 -->
	<div class="container_page">
		<div class="lang-radio-wrap">
			<a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
				<a-radio-button value="CH">中文版</a-radio-button>
				<a-radio-button value="EN">英文版</a-radio-button>
			</a-radio-group>
		</div>

		<a-form layout="inline" style="margin-bottom: 16px;">
			<a-form-item label="案例标题">
				<a-input v-model="filterData.keywords" placeholder="请输入案例标题/ID" />
			</a-form-item>
			<a-form-item label="地区">
				<a-input v-model="filterData.region" placeholder="请输入地区"/>
			</a-form-item>
			<a-form-item label="风险等级">
				<a-select style="width: 200px" v-model="filterData.riskLevel" class="mr12" placeholder="请选择执行状态"
					show-search option-filter-prop="name" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of commodityStatusList" :key="index" :value="item.value">
						{{ item.label }}
					</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item>
				<a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12" @click="toSearch(false)">重置</a-button>

				<a-button class="mr12" v-if="hasPermission('TRIGGERCASE_SCRIPT')" @click="scriptEdit">话术编辑</a-button>
				<a-button class="mr12" v-if="filterData.lang !== 'EN' &amp;&amp; hasPermission('TRIGGERCASE_IMPORT')" @click="importExcel">导入</a-button>
				<a-button v-if="filterData.lang !== 'EN' &amp;&amp; hasPermission('TRIGGERCASE_ADD')" @click="toAdd" type="primary" >新建案例</a-button>
			</a-form-item>
		</a-form>

		<!-- <div class="cate">
			<a-radio-group v-model="filterData.tagId" button-style="solid" @change="changeTab">
				<a-radio-button value="">全部</a-radio-button>
				<a-radio-button v-for="item in tags" :key="item.tagId" :value="item.tagId">
					{{ item.tagName }}
				</a-radio-button>
			</a-radio-group>
		</div> -->



		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<!-- 执行状态 -->
			<!-- ACTIVE-现行有效 PENDING-即将实施 OBSOLETE-已废止 -->
			<template slot="riskLevelRender" slot-scope="text, record">
				<a-tag color="#f50" v-if="record.riskLevel == 'HIGH'">
					高风险
				</a-tag>
				<a-tag color="#2db7f5" v-else-if="record.riskLevel == 'MEDIUM'">
					中风险
				</a-tag>
				<a-tag color="#87d068" v-else-if="record.riskLevel == 'LOW'">
					低风险
				</a-tag>
				<a-tag v-else></a-tag>
			</template>
			<!-- 发布状态 1 2-->
			<template slot="caseStatusRender" slot-scope="text, record">
				<div style="display: flex;align-items: center;">
					<a-switch :checked="!!record.caseStatus"
						@change="(checked) => handlePublishChange(checked, record)" />
					<a-tag style="margin-left: 10px;" color="#2db7f5" v-if="record.caseStatus == true">
						启用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else-if="record.caseStatus == false">
						禁用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else></a-tag>
				</div>
			</template>
			<template slot="indexSortender" slot-scope="text, record">
				<a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
					@keyup.enter="handleSaveSort(record)" /></template>
			<!-- 编辑，删除 -->
			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<span v-if="hasPermission('TRIGGERCASE_EDIT')"><a-button type="link" @click="toEdit(record)">编辑</a-button></span>
                <a-popconfirm title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
						<a-button type="link" v-if="filterData.lang !== 'EN' &amp;&amp; hasPermission('TRIGGERCASE_DEL')">删除</a-button>
					</a-popconfirm>
				</div>
			</template>
		</a-table>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<!-- :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" -->
			<a-form-model ref="formRef" :model="editModel" :rules="rules">
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="案例标题" prop="caseName" required>
							<a-input v-model="editModel.caseName" placeholder="请输入案例标题" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row :gutter="20">
					<a-col :span="12">
						<a-form-model-item label="地区" prop="region" required>
							<a-input v-model="editModel.region" placeholder="请输入地区" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="日期" prop="caseDate" required>
							<a-date-picker v-model="editModel.caseDate" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
								placeholder="请选择日期" style="width: 100%;" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row :gutter="20">
					<a-col :span="12">
						<a-form-model-item label="案号" prop="caseNumber" required>
							<a-input v-model="editModel.caseNumber" placeholder="请输入案号" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="执法部门" prop="enforcementDepartment" required>
							<a-input v-model="editModel.enforcementDepartment" placeholder="请输入执法部门" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- 第二行：标准名称 通栏 -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="违法事实" prop="violationFacts" required>
							<a-textarea v-model="editModel.violationFacts" :maxlength="500" show-count rows="4"
								placeholder="描述违法违规行为" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="案情描述" prop="caseDescription" required>
							<div ref="wangEditorCaseDesc"></div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="法律依据" prop="legalBasis" required>
							<div ref="wangEditorLegalBasis"></div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row :gutter="20">
					<a-col :span="12">
						<a-form-model-item label="罚款金额" prop="fineAmount" required>
							<a-input v-model="editModel.fineAmount" placeholder="请输入罚款金额" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="风险等级" prop="riskLevel" required>
							<a-select v-model="editModel.riskLevel" class="mr12" placeholder="请选择风险等级" show-search
								option-filter-prop="name" :filter-option="filterOption">
								<a-select-option v-for="(item, index) of commodityStatusList" :key="index"
									:value="item.value">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- 第三行：颁发部门 输入框+添加按钮 + 标签列表 todo -->
				<a-row>
					<a-col :span="24">
												<a-form-model-item
							:validateStatus="penaltyMeasuresError ? 'error' : ''"
							:help="penaltyMeasuresError ? '请添加处罚措施' : ''">
							<span slot="label"> <span style="color:#f5222d;font-size: 14px;">* </span>处罚措施</span>
							<div style="display: flex;">
								<a-input v-model="deptText" placeholder="请输入处罚措施" />
								<a-button style="width: 100px;margin-left: 20px;" type="primary" @click="addDept">+
									新增</a-button>
							</div>
							<div ref="dragContainer" style="width: 100%;">
								<div class="size_item" v-for="(item,idx) of deptList" :key="item._sortKey || idx" :data-key="item._sortKey">
									<a-button
										:type="item.highlightStatus ? 'danger' : 'default'"
										@click="toggleHighlight(idx)"
										style="margin-left: 4px;">{{ item.highlightStatus ? '已高亮' : '高亮' }}</a-button>
									<span class="left">{{ item.content }}</span>
									<a-icon class="right" type="delete" style="color:red;cursor:pointer"
										@click="deleteDept(idx)" />
								</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="发布状态" prop="caseStatus">
							<!-- <a-switch :checked="editModel.standardStatus"
								@change="(checked) => handleSwitch(checked)" /> -->
							<!-- 改用 v-model 双向绑定，移除 :checked -->
							<a-switch v-model="editModel.caseStatus" @change="handleSwitch" />
							<!-- 可选：加文字提示 -->
							<span style="margin-left:10px">{{ editModel.caseStatus ? '启用' : '禁用' }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="排序" prop="sort">
							<a-input v-model.number="editModel.sort" placeholder="显示顺序" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<div>监管部门记录列表顶部：</div>
			<div><a-input v-model.number="tipsModel.topTitle" placeholder="标题" /></div>
			<div><a-textarea v-model="tipsModel.topContent" placeholder="内容" :rows="3" /></div>
			<div style="margin-top:10px">监管部门记录详情底部：</div>
			<div><a-input v-model.number="tipsModel.bottomTitle" placeholder="标题" /></div>
			<div><a-textarea v-model="tipsModel.bottomContent" placeholder="内容" :rows="3" /></div>
		</a-modal>
		<a-modal title="导入处罚案例" :visible="importModel.flag" width="500px" :footer="null" @cancel="importModel.flag = false">
			<div style="display: flex; flex-direction: column; align-items: center; gap: 16px;">
				<a-button type="link" @click="handleDownloadTemplate">下载导入模板</a-button>
				<div class="import-upload-area" @click="triggerFileSelect" style="width: 100%; min-height: 160px; border: 2px dashed #d9d9d9; border-radius: 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; background: #fafafa;">
					<div style="font-size: 48px; color: #40a9ff; line-height: 1;">+</div>
					<div style="margin-top: 8px; color: #666;">点击选择 Excel 文件</div>
					<div style="margin-top: 4px; font-size: 12px; color: #999;">支持 .xlsx 格式</div>
				</div>
				<input ref="importFileInput" type="file" accept=".xlsx" style="display: none" @change="handleImport" />
				<div v-if="importModel.selectedFile" style="color: #333;">
					已选择{{ importModel.selectedFile.name }}
				</div>
				<a-button v-if="importModel.selectedFile" type="primary" :loading="importModel.uploading" @click="handleUpload">
					开始导入
				</a-button>
			</div>
		</a-modal>
		<a-modal title="导入结果" :visible="importModel.resultVisible" width="500px" :footer="null" @cancel="importModel.resultVisible = false">
			<div style="padding: 16px 0;" v-if="importModel.resultData">
				<div v-if="importModel.resultData.fileUrl" style="margin-bottom: 16px; padding: 12px; background: #fff2f0; border: 1px solid #ffccc7; border-radius: 4px;">
					部分数据导入失败，请下载错误文件查看详情
					<div style="margin-top: 8px;">
						<a-button type="primary" @click="downloadErrorFile(importModel.resultData.fileUrl)">
							下载错误文件
						</a-button>
					</div>
				</div>
				<div style="text-align: center;">
					<a-button @click="importModel.resultVisible = false">关闭</a-button>
				</div>
			</div>
		</a-modal>

	</div>
</template>

<script>
	import {
		ossUpload
	} from "../../utils/oss";
	import Sortable from 'sortablejs';
	import E from 'wangeditor';
	import {
		getTagCategoriesApi,
		importPenaltyCaseApi, // 导入
		getPenaltyCaseListApi, //  执行标准列表
		getPenaltyCaseDetailApi, //  执行标准详情
		savePenaltyCaseApi, //  执行标准新增/编辑
		deletePenaltyCaseApi, //    执行标准删除
		updatePenaltyCaseStatusApi, //  执行标准 修改状态
		updatePenaltyCaseSortApi, //  修改排序
		getBottomWordingApi, //  页面话术编辑 获取
		saveBottomWordingApi, //  页面话术编辑 保存
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				editorCaseDesc: null,
				editorLegalBasis: null,
				commodityStatusList: [
					{
						label: "高风险",
						value: 'HIGH',
					},
					{
						label: "中风险",
						value: 'MEDIUM',
					},
					{
						label: "低风险",
						value: 'LOW',
					},
				],
				columns: [{
						title: 'ID',
						dataIndex: 'caseCode',
						key: 'caseCode',
					},
					{
						title: '案例标题',
						dataIndex: 'caseName',
						key: 'caseName',
					},
					{
						title: '地区',
						dataIndex: 'region',
						key: 'region',
					},
					{
						title: '案例日期',
						dataIndex: 'caseDate',
						key: 'caseDate',
					},
					{
						title: '罚款金额',
						dataIndex: 'fineAmount',
						key: 'fineAmount',
					},
					{
						title: '风险等级',
						dataIndex: 'riskLevel',
						key: 'riskLevel',
						scopedSlots: {
							customRender: 'riskLevelRender'
						},
					},
					{
						title: '发布状态',
						dataIndex: 'caseStatus',
						key: 'caseStatus',
						scopedSlots: {
							customRender: 'caseStatusRender'
						},
					},
					{
						title: '排序',
						dataIndex: 'sort',
						key: 'sort',
						scopedSlots: {
							customRender: 'indexSortender'
						},
					},
					{
						title: '创建时间',
						dataIndex: 'createTime',
						key: 'createTime',
					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					topTitle: "",
					topContent: "",
					bottomTitle: "",
					bottomContent: "",
					type: 'PENALTY',
					onOk: () => {},
				},
				importModel: {
					flag: false,
					selectedFile: null,
					uploading: false,
					resultVisible: false,
					resultData: null,
				},
				editModel: {
					flag: false,
					title: "",
					caseId: '',
					executionStandardCode: '',
					standardCode: '',
					tagId: '',
					tagName: '',
					lang: '',
					standardName: '',
					issuingAuthority: '',
					implementationStatus: '',
					standardStatus: false,
					sort: 0,
					scopeOfApplication: '',
					standardDescription: '',
					otherStand: '',
					physicochemicalIndicators: '',
					customContent: '',
					standardDocument: '',
					standardId: '',
					implementationDate: null,
					createTime: '',
					onOk: () => {},
				},
				formState: {
					"iconUrl": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					keywords: "",
					region: "",
					riskLevel: undefined,
					lang: "CH",
				},
				tags: [],
				deptText: "",
				deptList: [],
				mainText: "",
				mainList: [],
				penaltyMeasuresError: false,
				rules: {
					caseName: [{ required: true, message: '请输入案例标题', trigger: 'blur' }],
					region: [{ required: true, message: '请输入地区', trigger: 'blur' }],
					caseDate: [{ required: true, message: '请选择案例日期', trigger: 'change' }],
					caseNumber: [{ required: true, message: '请输入案号', trigger: 'blur' }],
					enforcementDepartment: [{ required: true, message: '请输入执法部门', trigger: 'blur' }],
					violationFacts: [{ required: true, message: '请输入违法事实', trigger: 'blur' }],
					caseDescription: [{ required: true, message: '请输入案情描述', trigger: 'blur' }],
					legalBasis: [{ required: true, message: '请输入法律依据', trigger: 'blur' }],
					fineAmount: [{ required: true, message: '请输入罚款金额', trigger: 'blur' }],
					riskLevel: [{ required: true, message: '请选择风险等级', trigger: 'change' }],
				},
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('triggerCase_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
			} else {}
			this.filterData.lang = 'CH';
			this.getData(1)
			this.getTagsLabel()
			this.initDragBrand1()
			this.initDragBrand2()
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('triggerCase_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			hasPermission(permission) {
				const resources = this.$store.state.userInfo.resources;
				return resources && resources.split(";").includes(permission);
			},
			// 切换发布状态（带确认提示）
			handlePublishChange(checked, record) {
				// 动态生成提示文案
				let content = '';
				if (checked) {
					// 切换为 启用
					content = '切换为启用状态，则当前数据用户前端可查看，确认变更当前数据状态？';
				} else {
					// 切换为 禁用
					content = '切换为禁用状态，则当前数据前端不可查看，确认变更当前数据状态？';
				}
				this.$confirm({
					title: '操作确认',
					content: content,
					okText: '确定',
					cancelText: '取消',
					onOk: () => {
						// 确认后执行的操作
						// record.standardStatus = checked ? 1 : 0; // 接口需要数字，存回数字
						// 这里可以调用接口更新状态
						// TODO
						this.updateStatusApi(record.caseId)
						console.log('发布状态已更新为：', record.caseStatus);
					},
					onCancel: () => {
						// 取消时，保持开关原来的状态不变
						console.log('已取消操作');
					}
				});
			},
			updateStatusApi(caseId) {
				updatePenaltyCaseStatusApi({
						caseId: caseId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								"修改成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					})
			},

			// 保存排序（输入框回车/失焦触发）
			handleSaveSort(record) {
				// 排序号为空不提交
				if (record.sort === undefined || record.sort === null || record.sort === '') {
					return
				}
				// 调用你已有的排序接口
				updatePenaltyCaseSortApi({
					caseId: record.caseId,
					sort: record.sort
				}).then(res => {
					if (res.resultStatus) {
						this.$message.success('排序保存成功')
						this.getData(this.pageInfo.current) // 刷新列表，实现重排
					} else {
						this.$message.error('保存失败')
					}
				}).catch(err => {
					this.$message.error('保存失败')
				})
			},

			changeTabTop() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},

			changeTab() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},
			initDragBrand1() {
				const el = this.$refs.dragContainer
				if (!el) return
				if (el._sortableInstance) el._sortableInstance.destroy()
				el._sortableInstance = Sortable.create(el, {
					animation: 150, // 流畅动画
					draggable: '.size_item',
					forceFallback: false,
					ghostClass: 'sort-ghost',

					// 拖拽结束
					onEnd: (evt) => {
						// 有 _sortKey 时按 DOM data-key 顺序重排，避免 index key 导致的顺序错乱
						if (this.deptList.length > 0 && this.deptList[0]._sortKey !== undefined) {
							const domOrder = Array.from(el.children).map(child => child.dataset.key).filter(Boolean);
							if (domOrder.length === this.deptList.length) {
								const reordered = domOrder.map(k =>
									this.deptList.find(item => String(item._sortKey) === k)
								).filter(Boolean);
								if (reordered.length === this.deptList.length) {
									this.deptList.splice(0, this.deptList.length, ...reordered);
								}
							}
						} else {
							const {
								oldIndex,
								newIndex
							} = evt
							// 数组顺序同步（核心！）
							const moveItem = this.deptList.splice(oldIndex, 1)[0]
							this.deptList.splice(newIndex, 0, moveItem)
						}
					},
				})
			},
			deleteDept(index) {
				this.deptList.splice(index, 1);
			},
			addDept() {
				if (!this.deptText) return;
				this.deptList.push({
					highlightStatus: false,
					content: this.deptText,
					_sortKey: Date.now() + Math.random()
				});
				this.deptText = '';
				this.penaltyMeasuresError = false;
			},
			toggleHighlight(idx) {
				const item = this.deptList[idx];
				const isCurrentlyHighlighted = item.highlightStatus;
				// 先清除所有高亮
				this.deptList.forEach(d => { d.highlightStatus = 0 });
				// 如果之前没高亮，则高亮当前项
				if (!isCurrentlyHighlighted) {
					item.highlightStatus = 1;
				}
			},
			initDragBrand2() {
				const el = this.$refs.dragContainerMain
				if (!el) return
				this.sortable = Sortable.create(el, {
					animation: 150, // 流畅动画
					handle: '.size_item', // 可拖拽元素
					draggable: '.size_item',
					forceFallback: false,
					ghostClass: 'sort-ghost',

					// 拖拽结束
					onEnd: (evt) => {
						const {
							oldIndex,
							newIndex
						} = evt
						// 数组顺序同步（核心！）
						const moveItem = this.mainList.splice(oldIndex, 1)[0]
						this.mainList.splice(newIndex, 0, moveItem)
					},
				})
			},
			deletemain(index) {
				this.mainList.splice(index, 1);
			},
			addMain() {
				if (!this.mainText) return;
				this.mainList.push(this.mainText);
				this.mainText = '';
			},
			getTagsLabel() {
				getTagCategoriesApi({
					tagTypeCategory: 'EXECUTION_STANDARD'
				}).then((res) => {
					if (res.resultStatus) {
						this.tags = res.resultData[0].tags

					} else {}

				})


			},
			handleCategoryChange() {
				// 切换分类后，重置页码并刷新表格
				this.pageInfo.current = 1;
				this.loadTableData();
			},
			handleSwitch(checked) {
				// this.editModel.standardStatus = checked
			},


			handleBlur() {
				console.log('blur');
			},
			handleFocus() {
				console.log('focus');
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						keywords: "",
						region: "",
						riskLevel: undefined,
						lang: "CH",
					};
					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getPenaltyCaseListApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						lang: this.filterData.lang,
						keywords: this.filterData.keywords,
						region: this.filterData.region,
						riskLevel: this.filterData.riskLevel,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.pageInfo.total = res.resultData.totalNum || 0;

						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
				this.destroyEditor();
				this.penaltyMeasuresError = false;
				this.deptList = [];
				this.deptText = '';
				if (this.$refs.formRef) {
					this.$refs.formRef.clearValidate();
				}
				this.editModel = {
					flag: true,
					title: "新建处罚案例",
					caseId: '',
					"caseName": "", //案例标题
					"region": "", //地区
					"caseDate": "", //日期
					"caseNumber": "", //案号
					"enforcementDepartment": "", //执法部门
					"violationFacts": "", //违法事实
					"caseDescription": "", //案情描述
					"legalBasis": "", //法律依据
					"fineAmount": "", //罚款金额
					"riskLevel": undefined, //风险等级：HIGH-高风险 MEDIUM-中风险 LOW-低风险
					// "penaltyMeasures": "[{\"highlightStatus\":1,\"content\":\"\"}]", //处罚措施
					"sort": null, //排序
					"caseStatus": undefined, //状态

					sort: null,
					onOk: this.sureEdit,
				};
				this.$nextTick(() => {
					this.initDragBrand1();
					this.initEditorCaseDesc();
					this.initEditorLegalBasis();
				});
			},
			toEdit(data) {
				this.destroyEditor();
				this.penaltyMeasuresError = false;
				getPenaltyCaseDetailApi({
						caseId: data.caseId,
					})
					.then((res) => {
						if (res.resultStatus) {
							const result = res.resultData;
							if (result.penaltyMeasures) {
								const arr = JSON.parse(result.penaltyMeasures)
								this.deptList = arr.map(item => ({ ...item, _sortKey: Date.now() + Math.random() }))
							}
							this.editModel = {
								"flag": true,
								"title": "编辑处罚案例",
								caseId: result.caseId ?? '',
								caseName: result.caseName ?? '',
								region: result.region ?? '',
								caseDate: result.caseDate ?? '',
								caseNumber: result.caseNumber ?? '',
								enforcementDepartment: result.enforcementDepartment ?? '',
								violationFacts: result.violationFacts ?? '',
								caseDescription: result.caseDescription ?? '',
								legalBasis: result.legalBasis ?? '',
								fineAmount: result.fineAmount ?? '',
								riskLevel: result.riskLevel ?? undefined,
								penaltyMeasures: result.penaltyMeasures,
								sort: result.sort ?? null,
								caseStatus: result.caseStatus,
								onOk: this.sureEdit,
							};
				this.$nextTick(() => {
					this.initDragBrand1();
					this.initEditorCaseDesc();
					this.initEditorLegalBasis();
				});
						} else {
							console.log("res");
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},
			confirm() {

			},
			sureScript(data) {
				const configValue = JSON.stringify({
					topTitle: this.tipsModel.topTitle,
					topContent: this.tipsModel.topContent,
					bottomTitle: this.tipsModel.bottomTitle,
					bottomContent: this.tipsModel.bottomContent,
				});
				const params = {
					configId: this.tipsModel.configId,
					configValue,
					type: 'PENALTY',
					lang: this.filterData.lang || 'CH',
				};
				saveBottomWordingApi(params).then((res) => {
					if (res.resultStatus) {
						this.$message.success('保存成功');
						this.tipsModel.flag = false;
					}
				}).catch((err) => {
					console.log(err);
					this.$message.error('保存失败');
				});
			},
			// 话术编辑
			scriptEdit() {
				const lang = this.filterData.lang || 'CH';
				getBottomWordingApi({ type: 'PENALTY', lang }).then((res) => {
					if (res.resultStatus) {
						const data = res.resultData || {};
						let parsed = { topTitle: '', topContent: '', bottomTitle: '', bottomContent: '' };
						if (data.configValue) {
							try {
								parsed = JSON.parse(data.configValue);
							} catch(e) {
								console.log(e);
							}
						}
						this.tipsModel = {
							flag: true,
							title: '处罚案例页面话术编辑',
							configId: data.configId,
							topTitle: parsed.topTitle || '',
							topContent: parsed.topContent || '',
							bottomTitle: parsed.bottomTitle || '',
							bottomContent: parsed.bottomContent || '',
							onOk: this.sureScript,
						};
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			sureEdit(data) {
				this.penaltyMeasuresError = false;

				let hasCustomError = false;
				if (!this.deptList.length) { this.penaltyMeasuresError = true; hasCustomError = true; }

				this.$refs.formRef.validate((valid) => {
					if (!valid || hasCustomError) {
						return;
					}

					savePenaltyCaseApi({
						caseId: this.editModel.caseId || 0,
						"caseName": this.editModel.caseName, //案例标题
						"region": this.editModel.region, //地区
						"caseDate": this.editModel.caseDate, //日期
						"caseNumber": this.editModel.caseNumber, //案号
						"enforcementDepartment": this.editModel.enforcementDepartment, //执法部门
						"violationFacts": this.editModel.violationFacts, //违法事实
						"caseDescription": this.editModel.caseDescription, //案情描述
						"legalBasis": this.editModel.legalBasis, //法律依据
						"fineAmount": this.editModel.fineAmount, //罚款金额
						"riskLevel": this.editModel.riskLevel, //风险等级：HIGH-高风险 MEDIUM-中风险 LOW-低风险
						"penaltyMeasures": JSON.stringify(this.deptList.map(({ _sortKey, ...rest }) => rest)), //处罚措施
						"sort": this.editModel.sort, //排序
						"caseStatus": this.editModel.caseStatus //状态
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.editModel.caseId ? "编辑成功" : "新增成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					});
				});
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.iconUrl,
				};
			},
			sureDelete(record) {
				deletePenaltyCaseApi({
						caseId: record.caseId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(this.pageInfo.current);
					});
			},
			// 导入
			importExcel() {
				this.importModel.flag = true;
				this.importModel.selectedFile = null;
				this.importModel.resultData = null;
			},
			triggerFileSelect() {
				this.$refs.importFileInput.value = null;
				this.$refs.importFileInput.click();
			},
			handleImport(e) {
				this.importModel.selectedFile = e.target.files[0] || null;
			},
			handleUpload() {
				const file = this.importModel.selectedFile;
				if (!file) return;
				const formData = new FormData();
				formData.append('file', file);
				this.importModel.uploading = true;
				importPenaltyCaseApi(formData).then((res) => {
					if (res.resultStatus) {
						const data = res.resultData || {};
						if (data.fileUrl) {
							this.importModel.resultData = data;
							this.importModel.resultVisible = true;
						} else {
							this.$message.success(`导入成功，共 ${data.totalCount || 0} 条`);
							this.importModel.flag = false;
							this.getData(this.pageInfo.current);
						}
					} else {
						this.$message.error(res.errorMessage || '导入失败');
					}
				}).catch((err) => {
					console.error(err);
					this.$message.error('导入失败');
				}).finally(() => {
					this.importModel.uploading = false;
				});
			},
			handleDownloadTemplate() {
				const link = document.createElement('a');
				link.href = 'https://oss.chongmi.online/wxapp/importExcel/处罚案例模板.xlsx';
				link.download = '处罚案例导入模板.xlsx';
				link.click();
			},
			downloadErrorFile(url) {
				const link = document.createElement('a');
				link.href = url;
				link.download = decodeURIComponent(url.substring(url.lastIndexOf('/') + 1));
				link.click();
			},
			initEditorCaseDesc() {
				if (!this.$refs.wangEditorCaseDesc) return;
				if (this.editorCaseDesc) { this.editorCaseDesc.destroy(); }
				this.editorCaseDesc = new E(this.$refs.wangEditorCaseDesc);
				this.editorCaseDesc.config.height = 300;
				this.editorCaseDesc.config.onchange = (html) => {
					this.editModel.caseDescription = html;
				};
				this.editorCaseDesc.create();
				if (this.editModel.caseDescription) {
					this.editorCaseDesc.txt.html(this.editModel.caseDescription);
				}
			},
			initEditorLegalBasis() {
				if (!this.$refs.wangEditorLegalBasis) return;
				if (this.editorLegalBasis) { this.editorLegalBasis.destroy(); }
				this.editorLegalBasis = new E(this.$refs.wangEditorLegalBasis);
				this.editorLegalBasis.config.height = 300;
				this.editorLegalBasis.config.onchange = (html) => {
					this.editModel.legalBasis = html;
				};
				this.editorLegalBasis.create();
				if (this.editModel.legalBasis) {
					this.editorLegalBasis.txt.html(this.editModel.legalBasis);
				}
			},
			destroyEditor() {
				if (this.editorCaseDesc) {
					this.editorCaseDesc.destroy();
					this.editorCaseDesc = null;
				}
				if (this.editorLegalBasis) {
					this.editorLegalBasis.destroy();
					this.editorLegalBasis = null;
				}
			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}

	.size_item {
		height: 50px;
		/* 改为固定高度，不要 min-height */
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		/* 间距改小，更美观 */
		cursor: move;
		padding: 0 10px;

		.left {
			flex: 1;
			padding-left: 10px;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.lang-radio-wrap {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}
	/* wangEditor 下拉菜单裁剪修复 */
	.w-e-toolbar {
		z-index: 99999 !important;
	}
</style>
